import { render, staticRenderFns } from "./anuncio.vue?vue&type=template&id=0f13d5e7"
import script from "./anuncio.vue?vue&type=script&lang=js"
export * from "./anuncio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports